// Which onboarding a person has seen. Apart from the screens (steps.ts) because
// progress events and device prefs store it, and they must not import UI copy.

/**
 * The onboarding a person has seen, stored as a number rather than a flag, on
 * the device and on the account. Bumping it re-shows onboarding to everyone,
 * signed in or not, without touching anyone's data.
 */
export const ONBOARDING_VERSION = 1;

/** A stored onboarding version: a whole number, 0 meaning none seen. */
export const isVersion = (x: unknown): x is number =>
	typeof x === "number" && Number.isInteger(x) && x >= 0;
